<script>
import { mapState } from "vuex";
import Footer from "@/components/footer";

export default {
  components: { Footer },
  beforeCreate: function () {
    document.body.className = 'experts';
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
};
</script>

<template>
  <div id="layout-wrapper">
    <header id="page-topbar">
      <div class="navbar-header">
        <div class="d-flex align-items-center pl-3 pl-lg-4">
          <img style="height:40px;" src="@/assets/images/logo-white.png" />
        </div>

        <div class="d-flex align-items-center pr-2 pr-lg-3">
          <b-dropdown right variant="black" toggle-class="header-item p-2">
            <template v-slot:button-content>
              <img v-if="account.user.avatar" class="rounded-circle header-profile-user" :src="account.user.avatar" alt="" />
              <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=000001&color=fff&name=' + account.user.name" alt="" />
              <span class="d-none d-md-inline-block ml-1">{{ account.user.username }}</span>
              <i class="mdi mdi-chevron-down d-none d-md-inline-block"></i>
            </template>
            <router-link tag="a" to="/login" class="dropdown-item py-2">
              <i class="bx bx-log-out align-middle mr-1"></i>
              <span>Sair</span>
            </router-link>
          </b-dropdown>
        </div>
      </div>
    </header>
    <div class="main-content ml-0">
      <div class="page-content">
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
